import classNames from 'classnames'
import { HTMLAttributes } from 'react'

const Offer = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    data-testid="offer"
    className={classNames(
      'flex flex-col p-6 border rounded-md place-items-center gap-y-2 border-border-default text-center',
      className
    )}
    {...props}
  />
)

export default Offer
